import { render, staticRenderFns } from "./page-loading-spinner.vue?vue&type=template&id=55d7b636&scoped=true"
import script from "./page-loading-spinner.vue?vue&type=script&lang=js"
export * from "./page-loading-spinner.vue?vue&type=script&lang=js"
import style0 from "./page-loading-spinner.vue?vue&type=style&index=0&id=55d7b636&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7b636",
  null
  
)

export default component.exports